
export const SALESFORCE_FIELD_VALUE = {
  RECORD_TYPE: '012J6000000kDQt',
  DEBUG_EMAIL: 'team.dev.shops+salesforce.webform.test@expondo.pl',
};

export const SALESFORCE_ACCEPTED_CHARACTER_SET = 'UTF-8';
